import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - SALES HISTORY
 * =======================================
 *
 * @module webregister.routes.salesHistory
 */
function SalesHistoryRoutesConfig($stateProvider: StateProvider) {
  $stateProvider.state(STATES.SALES_HISTORY, {
    url: ROUTES.SALES_HISTORY,
    onEnter($transition) {
      const params = $transition.params() || {}

      const {
        customer_id: customerId,
        promo_code: promoCode,
        promo_code_id: promoCodeId,
      } = params

      // Redirect all sales history routes to the new sales history service if the feature is enabled
      const urlParams = { customerId, promoCode, promoCodeId }
      const urlValues: string[] = []

      // Build and pass query params
      Object.keys(urlParams).forEach(key => {
        const value = (urlParams as $TSFixMe)[key]
        if (value !== undefined) {
          urlValues.push(`${key}=${value}`)
        }
      })

      const salesParams = urlValues.length ? `?${urlValues.join('&')}` : ''

      window.location.href = `${ROUTES.NEW_SALES_HISTORY_ALL}${salesParams}`
    },
    params: {
      // Filter data to be applied to sales history on page load
      filterData: null,
      // Active tab to be applied on the sales history page
      tab: null,
      customer: null,
    },
  })
}

angular.module('webregister.routes').config(SalesHistoryRoutesConfig)
